var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 11.6667C25.6541 11.6667 27.8797 12.5886 29.5206 14.2296C31.1615 15.8705 32.0834 18.0961 32.0834 20.4167V30.6251H26.2501V20.4167C26.2501 19.6432 25.9428 18.9013 25.3958 18.3544C24.8488 17.8074 24.107 17.5001 23.3334 17.5001C22.5599 17.5001 21.818 17.8074 21.271 18.3544C20.724 18.9013 20.4167 19.6432 20.4167 20.4167V30.6251H14.5834V20.4167C14.5834 18.0961 15.5053 15.8705 17.1462 14.2296C18.7872 12.5886 21.0128 11.6667 23.3334 11.6667Z",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75008 13.1251H2.91675V30.6251H8.75008V13.1251Z",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 8.75008C7.44424 8.75008 8.75008 7.44425 8.75008 5.83341C8.75008 4.22258 7.44424 2.91675 5.83341 2.91675C4.22258 2.91675 2.91675 4.22258 2.91675 5.83341C2.91675 7.44425 4.22258 8.75008 5.83341 8.75008Z",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.40d3b0cbd0ce8419b3b75e70dffe4949.svg";
export { ForwardRef as ReactComponent };